import React, {Component} from 'react';
import {Grid, Row, Col, Image} from 'react-bootstrap';
import './instruction_capture_identity_card.css';
import {connect} from 'react-redux';
import {setImage} from '../../redux/actionCreators';
import classnames from 'classnames';
import FooterContainer from '../../components/footer/FooterContainer';
import PageWithFooter from '../../components/page_with_footer/PageWithFooter';
import CircularProgressBarStep from '../../components/circular_progress_bar_step/CircularProgressBarStep';
import MainButton from '../../components/buttons/main_button/MainButton';

class InstructionCaptureIdentityCard extends Component {

    componentDidMount() {
        this.props.setImage(undefined);
    }

    render() {
        let icon;
        let epigraph = '';
        if (this.props.stepInfo.icon) {
            icon = require(`../../resources/images/${this.props.stepInfo.icon}`).default;
        }
        if (this.props.stepInfo.epigraph !== '') {
            epigraph = <h2 className={'epigraph'}>{this.props.stepInfo.epigraph}</h2>
        }
        let buttonText = this.props.stepInfo.buttonText && this.props.stepInfo.buttonText !== ''? this.props.stepInfo.buttonText : 'Continuar';
        return (
            <div
                className={classnames(
                    'instruction_capture_identity_card',
                    'page-layout',
                    {[this.props.stepInfo.additionalClass]: this.props.stepInfo.additionalClass && this.props.stepInfo.additionalClass !== ''},
                )}
            >
                
                <PageWithFooter
                    footer={(
                        <FooterContainer>
                            <MainButton 
                                onClick={this.props.nextStep}
                                text={buttonText}
                            />
                       </FooterContainer>
                    )}
                >
                <Grid>
                    <div className={'content'}>
                        <Row>
                            <Col xs={12}>
                                <div className={'number'}>
                                    <CircularProgressBarStep />
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                {epigraph}
                                <h1 className={'title'}>{this.props.stepInfo.title}</h1>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <div className="image">
                                    <Image src={icon}/>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <p className={'description'}>
                                    {this.props.stepInfo.description}
                                </p>
                            </Col>

                            {this.props.stepInfo.additional &&  this.props.stepInfo.additional !== '' &&
                                <Col xs={12}>
                                    <div className={'alert-box'}>
                                        <span className={'warning-icon'}>!</span> 
                                        <p className={'additional'}>
                                            {this.props.stepInfo.additional}
                                        </p>
                                    </div>
                                </Col>
                            }
                        </Row>
                    </div>
                
                </Grid>
                </PageWithFooter>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        stepInfo: state.stepInfo,
        image: state.image,
        background: state.background,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setImage(image) {
            dispatch(setImage(image));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(InstructionCaptureIdentityCard);
